// Angular
import { Injectable } from '@angular/core';

// NGRX & RXJS
import { BehaviorSubject, Observable} from 'rxjs';
import { map } from 'rxjs/operators';

// OLCI
import { MicroServicesService } from './micro-services.service';

export interface NotificationStatsResponse {
  payload: {
    unSeenCount: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class MessageCenterService {
  private menuOpenSource = new BehaviorSubject<boolean>(false);
  currentMenuOpen = this.menuOpenSource.asObservable();
  
  constructor(
    private microServicesService: MicroServicesService
  ) {}

  getUnseenNotificationCount(): Observable<{
    hasNewMessages: boolean;
    displayCount: string;
  }> {
    return this.microServicesService.getUnseenNotificationCount().pipe(
      map((res) => {
        const count = res?.payload?.unSeenCount ?? 0;
        return {
          hasNewMessages: count > 0,
          displayCount: count >= 100 ? '99+' : count.toString(),
        };
      })
    );
  }

  updateMenuOpen(menuOpen: boolean) {
    this.menuOpenSource.next(menuOpen);
  }
}
